<template>
  <div class="container-item image-card">  
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-9 col-xl-8 col-12">
        <div>
          <ImageElement :imageData="imageData" />
        </div>
        <div v-if="cardText.imageCredits" class="text-left creditos-picture">
          <span v-if="cardText.text">
            {{ cardText.text }}
          </span>
           <span class="author">| {{ cardText.imageCredits }}</span>
        </div>
      </div>
    </div>    
  </div>
</template>

<style lang="scss">

.creditos-picture {
  font-family: "Noto Sans";
  padding: 0 15px;
  color: #333;
  font-size: 15px;
  border-bottom: solid 1px #333;

  span {
    font-size: 15px;
  }
  
  .author {
    font-size: 15px;
    color: #747474;
  }
}
</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'SingleImage',
    mixins: [images],
    props: {
      cardText: Object 
    }
  }
</script>